module.exports = {
  label: 'Special Goods',
  CLASSNO: 'CLASS NO.',
  UNNO: 'UN NO.',
  PACKING: 'PACKING GROUP',
  EMS: 'EMS',
  Point: 'FLASH POINT',
  Isolation: 'Isolation',
  man24: '24HOUR EMERGENCY CONTACT',
  tel24: 'TELEPHONE NUMBER',
  ResponsibleParty: 'responsible party',
  HSCODE: 'HS CODE',
  ContractNbr: 'contract nbr',
  SHIPPER: 'Measurement (LxWxH)',
  PickTime: 'Pick up time',
  SeaPullution: 'Sea Pollution',
  GOH: 'GOH',
  Tier: 'Tier',
  Hanger: 'Hanger per tier',
  Ropes: 'Ropes per hanger',
  Knots: 'Knots per rope',
  ReformCost: 'Reform Cost',
  Warehouse: 'Warehouse',
  Reefer: 'Reefer',
  humidity: 'humidity(%)',
  ventilation: 'ventilation(m3)',
  Business: 'Business Inspection',
  PTI: 'PTI days',
  ContainerYard: 'Container yard',
  Address: 'Address ',
  StuffingTime: 'Stuffing time',
  DeliverTime: 'Deliver port district ',
  WarehousingTime: 'Warehousing time ',
  DoccutoffTime: 'Doc cut off time',
  CustomsCutoffTime: 'Customs cut off time',
  CorrectTransportName: 'Correct transport name',
  SecondarySpecialGoods: 'Secondary special goods',
  GrossWeight: 'Gross weight',
  NeatWeight: 'Neat weight',
  OuterPackagingType: 'Outer packaging type',
  OuterPackagingQuantity: 'Outer packaging quantity',
  InnerPackagingType: 'Inner packaging type',
  InnerPackagingQuantity: 'Inner packaging quantity',
  Remark: 'Remark',
  Add: 'Add',
  Delete: 'Delete',
  PackingCode: 'Packing code',
  Import: 'Import',
  FillIn: 'Fill in',
  OnlyEnterYN: 'Only enter Y or N',
  ThisFieldRequired: 'This field is required if outer packaging type is 4G',
  HumidityToolTip: 'HMD = Percent of moisture in the Air',
  Temp: 'Temperature',
  VentilationWse: 'Ventilation',
  VgmWeight: 'VGM Weight',
  dgContactEmail: 'DG Contact Email',
  dgContactFax: 'DG Contact Fax',
  bookingNo: 'Booking No',
  TemperatureUnit: 'Temperature Unit'
}
